import { ApiService } from '../model/Api.model';
import { AxiosInstance } from 'axios';
import { IPreprecatorio } from '../interface/entuba/prePrecatorio/IPrePrecatorio';
import { IPricingBatchItem } from '../interface/IPricingBatchItem';
import { IPreprecatorioBatch } from '../interface/entuba/prePrecatorio/IPreprecatorioBatch';


enum PrePrecatorioServiceEnum {
  getAll = "/all",
  getAllBatchs = '/all-batchs',
  getItems = "/items",
  prePrecatorio = ""
}

export default class PrePrecatorioService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/pre-precatorio");
  }

  public getAllBatchs = async (): Promise<IPreprecatorioBatch[]> => await this.GET(PrePrecatorioServiceEnum.getAllBatchs);
  public getItems = async (): Promise<IPricingBatchItem[]> => await this.GET(PrePrecatorioServiceEnum.getItems);
  public startProcess = async (data: IPreprecatorio) => await this.POST(PrePrecatorioServiceEnum.prePrecatorio, data);
  public getDetail = async (id: number): Promise<IPreprecatorio> => await this.GET(`${PrePrecatorioServiceEnum.prePrecatorio}/${id}`);
}